/* ============================================================
   NOORA WEAR — Theme JS
   ============================================================ */
(function () {
  'use strict';

  // -- Money formatting (Shopify-compatible) -----------------
  function formatMoney(cents) {
    var fmt = window.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  // -- Cart drawer ------------------------------------------
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCart);
  });
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeCart(); });

  // -- Refresh cart drawer from API -------------------------
  function refreshCart() {
    return fetch(window.routes.cart_url + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sub = document.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = formatMoney(cart.total_price);
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      });
  }

  // -- Add to cart (PDP) ------------------------------------
  document.querySelectorAll('form.product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) { btn.disabled = true; btn.dataset.originalLabel = btn.innerHTML; btn.textContent = 'Adding…'; }

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: new URLSearchParams(new FormData(form)).toString()
      }).then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            alert(data.description || window.cartStrings.error);
          } else {
            return refreshCart().then(openCart);
          }
        }).catch(function () { alert(window.cartStrings.error); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.originalLabel || 'Add to bag'; }
        });
    });
  });

  // -- Quantity inputs (drawer + cart page) -----------------
  function changeQty(key, qty) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); });
  }
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-decrease]');
    var inc = e.target.closest('[data-qty-increase]');
    var rm  = e.target.closest('[data-cart-remove]');
    if (dec || inc) {
      var input = dec ? dec.parentElement.querySelector('[data-qty-input]') : inc.parentElement.querySelector('[data-qty-input]');
      if (!input) return;
      var key = (dec || inc).dataset.key;
      var newVal = Math.max(parseInt(input.value || '1', 10) + (dec ? -1 : 1), 0);
      input.value = newVal;
      if (key) changeQty(key, newVal);
    }
    if (rm) {
      e.preventDefault();
      changeQty(rm.dataset.key, 0);
    }
  });

  // -- Variant picker (PDP) ---------------------------------
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var dataEl = picker.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = picker.closest('section').querySelector('form.product-form');
    var idInput = form && form.querySelector('[data-variant-id]');
    var addBtn = form && form.querySelector('[data-add-to-cart]');
    var priceEl = form && form.querySelector('[data-add-price]');
    var mainImg = document.getElementById('main-product-image');

    function getSelected() {
      var values = [];
      picker.querySelectorAll('.product__option').forEach(function (opt) {
        var sel = opt.querySelector('.is-selected');
        values.push(sel ? sel.dataset.optionValue : null);
      });
      return values;
    }

    function findVariant(values) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
    }

    // For each axis, compute which option values can pair with the
    // currently-selected values on the *other* axes to form a real variant.
    // Values that can't are marked .is-disabled so shoppers see the
    // mismatch up front (SHEIN/AliExpress sparse grids are common — Style
    // Type "A" only ships with 6 of the 10 colors, etc.). Without this a
    // user can pick Burgundy + Multicolor (no such variant) and the page
    // silently keeps the prior variant on the form, shipping the wrong
    // item.
    function refreshAvailability() {
      var values = getSelected();
      picker.querySelectorAll('.product__option').forEach(function (group, axisIdx) {
        group.querySelectorAll('.option-value, .option-swatch').forEach(function (btn) {
          var probe = values.slice();
          probe[axisIdx] = btn.dataset.optionValue || btn.title;
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) {
              return probe[i] == null || o === probe[i];
            });
          });
          var unavailable = !match || !match.available;
          btn.classList.toggle('is-disabled', unavailable);
        });
      });
    }

    // Images whose alt ends in " - <Color>" belong to that color. When the
    // selected color has tagged images, show only those plus untagged
    // (shared) images; otherwise leave the full gallery visible.
    function showColorGallery() {
      var colorGroup = picker.querySelector('[data-color-option]');
      var sel = colorGroup && colorGroup.querySelector('.is-selected');
      var color = sel ? sel.dataset.optionValue : null;
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
      var hasTagged = color && thumbs.some(function (t) { return t.dataset.color === color; });
      thumbs.forEach(function (t) {
        t.style.display = (!hasTagged || !t.dataset.color || t.dataset.color === color) ? '' : 'none';
      });
    }

    // The headline price renders the product's lowest price; keep it in
    // step with the chosen variant (colors/sizes can be priced differently).
    function syncHeadPrice(variant) {
      var headPrice = document.querySelector('.product__price .price');
      if (!headPrice || !variant) return;
      headPrice.innerHTML = variant.compare_at_price > variant.price
        ? '<span class="sale">' + formatMoney(variant.price) + '</span> <span class="compare-at">' + formatMoney(variant.compare_at_price) + '</span>'
        : formatMoney(variant.price);
    }

    // Mirrors the hover tooltip for touch screens: print the selected
    // size's measurements under the size buttons.
    // -- Size measurements (hover card, under-button line, size guide) --
    // Data: {"parts":[{"name":"Dress","rows":[{"size":"S","us":"4","m":[[label,inches,cm]]}]}]}
    var chart = null;
    var chartEl = picker.querySelector('[data-size-chart]');
    try { chart = chartEl ? JSON.parse(chartEl.textContent) : null; } catch (e) { chart = null; }
    if (!chart || !chart.parts || !chart.parts.length) chart = null;
    var unit = 'in';
    try { unit = localStorage.getItem('noora-size-unit') || 'in'; } catch (e) {}

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function partLines(size) {
      if (!chart) return [];
      var multi = chart.parts.length > 1;
      return chart.parts.map(function (p) {
        var row = p.rows.filter(function (r) { return r.size === size; })[0];
        if (!row) return null;
        var txt = row.m.map(function (m) {
          return m[0] + ': ' + (unit === 'cm' ? m[2] + ' cm' : m[1] + ' in');
        }).join(', ');
        return (multi ? p.name + ' - ' : '') + txt;
      }).filter(Boolean);
    }

    function showMeasurement() {
      picker.querySelectorAll('[data-measure-box]').forEach(function (box) {
        var sel = box.parentElement.querySelector('.option-value.is-selected');
        box.textContent = sel ? partLines(sel.dataset.optionValue).join(' | ') : '';
      });
    }

    var card = null, hideTimer = null;
    function hideCard() { hideTimer = setTimeout(function () { if (card) card.hidden = true; }, 150); }
    function showCard(btn) {
      var lines = partLines(btn.dataset.optionValue);
      if (!lines.length) return;
      clearTimeout(hideTimer);
      if (!card) {
        card = el('div', 'size-card');
        card.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
        card.addEventListener('mouseleave', hideCard);
        document.body.appendChild(card);
      }
      card.innerHTML = '';
      card.appendChild(el('div', 'size-card__title', 'Product measurement'));
      lines.forEach(function (l) { card.appendChild(el('p', 'size-card__part', l)); });
      var link = el('button', 'size-card__link', 'View detail');
      link.type = 'button';
      link.addEventListener('click', function () { card.hidden = true; openGuide(); });
      card.appendChild(link);
      card.hidden = false;
      var r = btn.getBoundingClientRect();
      card.style.left = Math.max(8, Math.min(window.scrollX + r.left + r.width / 2 - 150, window.scrollX + document.documentElement.clientWidth - 308)) + 'px';
      card.style.top = (window.scrollY + r.top - card.offsetHeight - 10) + 'px';
    }

    var guide = null, guidePart = 0;
    function renderGuide() {
      var body = guide.querySelector('[data-guide-body]');
      body.innerHTML = '';
      var tabs = guide.querySelector('[data-guide-tabs]');
      tabs.innerHTML = '';
      if (chart.parts.length > 1) {
        chart.parts.forEach(function (p, i) {
          var t = el('button', i === guidePart ? 'is-on' : '', p.name);
          t.type = 'button';
          t.addEventListener('click', function () { guidePart = i; renderGuide(); });
          tabs.appendChild(t);
        });
      }
      guide.querySelectorAll('[data-unit]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.unit === unit); });
      var part = chart.parts[guidePart];
      var hasUS = part.rows.some(function (r) { return r.us; });
      var table = el('table');
      var head = el('tr');
      if (hasUS) head.appendChild(el('th', '', 'US'));
      head.appendChild(el('th', '', 'Size'));
      part.rows[0].m.forEach(function (m) { head.appendChild(el('th', '', m[0])); });
      table.appendChild(head);
      part.rows.forEach(function (r) {
        var tr = el('tr');
        if (hasUS) tr.appendChild(el('td', '', r.us || ''));
        tr.appendChild(el('td', '', r.size));
        r.m.forEach(function (m) { tr.appendChild(el('td', '', unit === 'cm' ? m[2] : m[1])); });
        table.appendChild(tr);
      });
      var scroll = el('div', 'size-guide__scroll');
      scroll.appendChild(table);
      body.appendChild(scroll);
      body.appendChild(el('p', 'size-guide__note', 'Garment measurements in ' + (unit === 'cm' ? 'centimeters' : 'inches') + ', taken flat by hand; allow 1-2 cm (about 0.5 in) difference.'));
    }
    function openGuide() {
      if (!chart) return;
      if (!guide) {
        guide = el('div', 'size-guide');
        guide.setAttribute('role', 'dialog');
        guide.setAttribute('aria-modal', 'true');
        var panel = el('div', 'size-guide__panel');
        var close = el('button', 'size-guide__close', '×');
        close.type = 'button';
        close.setAttribute('aria-label', 'Close size guide');
        close.addEventListener('click', function () { guide.hidden = true; });
        panel.appendChild(close);
        panel.appendChild(el('h2', 'size-guide__title', 'Size Guide'));
        var bar = el('div', 'size-guide__bar');
        bar.appendChild(el('span', '', 'Product chart'));
        var units = el('div', 'size-guide__units');
        ['in', 'cm'].forEach(function (u) {
          var b = el('button', '', u.toUpperCase());
          b.type = 'button';
          b.dataset.unit = u;
          b.addEventListener('click', function () {
            unit = u;
            try { localStorage.setItem('noora-size-unit', u); } catch (e) {}
            renderGuide();
            showMeasurement();
          });
          units.appendChild(b);
        });
        bar.appendChild(units);
        panel.appendChild(bar);
        var tabs = el('div', 'size-guide__tabs');
        tabs.setAttribute('data-guide-tabs', '');
        panel.appendChild(tabs);
        var body = el('div');
        body.setAttribute('data-guide-body', '');
        panel.appendChild(body);
        guide.appendChild(panel);
        guide.addEventListener('click', function (e) { if (e.target === guide) guide.hidden = true; });
        document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && guide) guide.hidden = true; });
        document.body.appendChild(guide);
      }
      renderGuide();
      guide.hidden = false;
    }

    if (chart) {
      picker.querySelectorAll('.option-value').forEach(function (btn) {
        btn.addEventListener('mouseenter', function () { showCard(btn); });
        btn.addEventListener('mouseleave', hideCard);
      });
      picker.querySelectorAll('[data-size-guide-open]').forEach(function (b) {
        b.addEventListener('click', openGuide);
      });
    }

    function update() {
      var values = getSelected();
      var variant = findVariant(values);
      refreshAvailability();
      if (!variant) {
        // Selected combination doesn't exist as a real variant. Don't ship
        // the wrong item — disable buy + tell the shopper why. Also blank
        // the price span so the message doesn't run into a stale dollar
        // amount ("Unavailable in this combination$23.18").
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.firstChild.textContent = 'Unavailable in this combination';
        }
        if (priceEl) priceEl.textContent = '';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      syncHeadPrice(variant);
      showColorGallery();
      showMeasurement();
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.firstChild.textContent = variant.available ? 'Add to bag — ' : 'Sold out';
      }
      // When a variant has a linked image (set by Boltdrop on import or by
      // the link-variants pipeline), swap the gallery to that image. Try
      // clicking the matching thumb first so active-state + data-full stay
      // in sync; if there's no thumb (image lives past the rendered limit
      // OR was published without a Liquid asset_url), fall back to setting
      // mainImg.src directly from variant.featured_image.src — Shopify
      // serves any size on demand via the &width= query param.
      if (variant.featured_image && variant.featured_image.id) {
        var match = document.querySelector('[data-thumb][data-image-id="' + variant.featured_image.id + '"]');
        if (match) {
          match.click();
        } else if (mainImg && variant.featured_image.src) {
          var src = variant.featured_image.src;
          mainImg.removeAttribute('srcset');
          mainImg.src = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=1600';
        }
      }
      // Update URL with variant id
      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }

    picker.querySelectorAll('.option-value, .option-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var siblings = btn.parentElement.querySelectorAll('.option-value, .option-swatch');
        siblings.forEach(function (s) { s.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var label = btn.closest('.product__option').querySelector('[data-selected-value]');
        if (label) label.textContent = btn.dataset.optionValue || btn.title;
        update();
      });
    });

    // Initial pass so unavailable swatches are visibly dimmed on first paint.
    refreshAvailability();
    syncHeadPrice(findVariant(getSelected()));
    showColorGallery();
    showMeasurement();
  });

  // -- Image thumbnails (PDP) -------------------------------
  // Each thumb carries `data-full` with the 1600w CDN URL. The previous
  // implementation tried to upgrade the thumb's 200w URL via a string
  // replace ("200x" → "1200x"), which only worked for Shopify's legacy
  // `_200x.jpg` scheme — the modern `?width=200` query-param form left
  // the URL untouched, so clicking a thumb swapped the main image to the
  // tiny thumbnail and it rendered blurry. Read `data-full` directly.
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.getElementById('main-product-image');
      var full = thumb.getAttribute('data-full');
      // Video thumbs swap the main image for that product video.
      var videoId = thumb.hasAttribute('data-video-thumb') ? thumb.getAttribute('data-media-id') : null;
      document.querySelectorAll('[data-main-video]').forEach(function (wrap) {
        var on = wrap.getAttribute('data-main-video') === videoId;
        var vid = wrap.querySelector('video');
        wrap.hidden = !on;
        if (vid) { if (on) { vid.play().catch(function () {}); } else { vid.pause(); } }
      });
      if (main) main.style.display = videoId ? 'none' : '';
      // Drop the server-rendered srcset: browsers prefer it over src, so
      // without this the main image never visibly changes.
      if (main && full) { main.removeAttribute('srcset'); main.src = full; }
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // -- Mobile nav -------------------------------------------
  var mnav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-menu-open]').forEach(function (el) {
    el.addEventListener('click', function () { if (mnav) mnav.classList.add('is-open'); });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (el) {
    el.addEventListener('click', function () { if (mnav) mnav.classList.remove('is-open'); });
  });

  // -- Search toggle (placeholder, redirect to /search) -----
  document.querySelectorAll('[data-search-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = window.routes.predictive_search_url ? '/search' : '#';
    });
  });
})();
